<template>
    <div class="order_Info padding-20 bgc box-shadow">
        <div class="order_info_box">
            <div class="info_box">
                <p class="title_text">订单信息</p>
            </div>
            <div class="info_box">
                <div class="left_box">
                    <span>订单号：</span>
                    <span>{{tableData[0].orderno}}</span>
                </div>
                <div class="center_box">
                    <span>订单类型：</span>
                    <span>{{tableData[0].mktypetext}}</span>
                </div>
                <div class="right_box">
                    <span>订单状态：</span>
                    <span>{{tableData[0].statustext}}</span>
                </div>
                <div>
                    <span>渠道：</span>
                    <span>{{tableData[0].channelname}}</span>
                </div>
            </div>
            <div class="info_box">
                <div class="left_box">
                    <span>下单时间：</span>
                    <span>{{tableData[0].datetime}}</span>
                </div>
                <div class="center_box">
                    <span>支付方式：</span>
                    <span>{{tableData[0].paytypetext}}</span>
                </div>
                <div class="right_box">
                    <span>渠道来源：</span>
                    <span>{{tableData[0].ordersourcetext}}</span>
                </div>
                <div>
                    <span>推广员：</span>
                    <span>{{tableData[0].promotercustomername}}</span>
                </div>
            </div>
            <div class="info_box">
                <p class="title_text">买家信息</p>
            </div>
            <div class="info_box">
                <div class="left_box">
                    <span>买家昵称：</span>
                    <img v-lazy="tableData[0].customericonurl === '' ? tableData[0].coverurl : tableData[0].customericonurl" alt="">
                    <span>{{tableData[0].customername}}</span>
                </div>
                <div class="center_box">
                    <span>联系电话：</span>
                    <span>{{tableData[0].mobileno}}</span>
                </div>
                <div class="right_box"></div>
            </div>
            <div class="table_box">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column label="商品名称" width="320">
                        <template slot-scope="scope">
                            <div class="goods_name_box">
                                <img v-lazy="scope.row.coverurl" alt="">
                                <span :title="scope.row.kmcname">{{scope.row.kmcname}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="kmctypetext" label="商品类型" align='center'></el-table-column>
                    <el-table-column prop="uprice" label="单价（元）" align='center'></el-table-column>
                    <el-table-column prop="quantity" label="数量" align='center'></el-table-column>
                    <el-table-column prop="couponmoney" label="优惠（元）" align='center'></el-table-column>
                    <el-table-column prop="finalpaymoney" label="小计（元）" align='center'></el-table-column>
                    <el-table-column label="操作" align='center'>
                        <!-- <el-button type="text" @click="refund()">退款</el-button> -->
                    </el-table-column>
                </el-table>
            </div>
            <div class="info_box">
                订单合计&nbsp;<span>{{tableData[0].quantity ? tableData[0].quantity : 0}}</span>&nbsp;件商品，实付：<span>¥&nbsp;{{tableData[0].finalpaymoney ? tableData[0].finalpaymoney : '0.00'}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {findOrderInfo} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'OrderInfo',
    data() {
        return {
            tableData: [{
                couponcode: null,
                couponmoney: null,
                coverurl: null,
                customericonattid: null,
                customericonurl: null,
                customerinnerid: null,
                customername: null,
                datetime: null,
                finalpaymoney: null,
                kmcinnerid: null,
                kmcname: null,
                kmctype: 1,
                kmctypetext: null,
                mktype: null,
                mktypetext: null,
                mobileno: null,
                nowprice: null,
                orderinnerid: null,
                orderno: null,
                ordersource: null,
                ordersourcetext: null,
                paytype: null,
                paytypetext: null,
                promotercustomerinnerid: null,
                promotercustomername: null,
                quantity: null,
                status: null,
                statustext: null,
                uprice: null
            }]
        }
    },
    created() {
        this.getOrderInfo()
    },
    mounted() {},
    methods: {
        getOrderInfo() {
            this.setLoading(true)
            findOrderInfo({
                url: `/api/admin/order/${this.$route.query.orderinnerid}`,
                success: data => {
                    this.setLoading(false)
                    this.tableData = [data.data]
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 退款按钮
        refund() {
            this.$message({type: 'success', message: '退款测试消息!'})
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .order_Info{
        padding-bottom: 100px;
        .title_text{
            color: #303133;
            font-size: 16px;
            border-left: 2px solid #409EFF;
            padding-left: 10px;
            font-weight: bold;
        }
        .order_info_box{
            min-height: 300px;
            font-size: 14px;
            .info_box{
                display: flex;
                align-items: center;
                width: 100%;
                height: 40px;
                &>div{
                    width: 22%;
                    span:nth-of-type(1){
                        color: #606266;
                    }
                    span:nth-of-type(2){
                        color: #001529;
                    }
                }
                .left_box{
                    width: 34%;
                }
                // .center_box{
                //     min-width: 320px;
                // }
                // .right_box{
                //     min-width: 300px;
                // }
            }
            .info_box:nth-of-type(1){
                height: 20px;
            }
            .info_box:nth-of-type(2){
                border-bottom: 1px solid #DCDFE6;
                font-size: 14px;
                height: 50px;
                padding-left: 10px;
                height: 56px;
            }
            .info_box:nth-of-type(3){
                margin-top: 5px;
                padding-left: 10px;
            }
            .info_box:nth-of-type(4){
                margin-top: 30px;
                margin-bottom: 20px;
                height: 20px;
            }
            .info_box:nth-of-type(5){
                height: 50px;
                padding-left: 10px;
                .left_box{
                    display: flex;
                    align-items: center;
                    img{
                        width: 50px;
                        height: 50px;
                        border-radius: 100%;
                        margin: 0 10px;
                    }
                }
            }
            .info_box:nth-last-of-type(1){
                margin-top: 20px;
                padding-right: 20px;
                justify-content: flex-end;
                font-weight: bold;
            }
            .table_box{
                margin-top: 30px;
                .el-table th>.cell {
                    font-size:16px;
                    font-family:PingFangSC-Medium;
                    font-weight: bold;
                    color:rgba(48,49,51,1);
                }
                .goods_name_box{
                    display: flex;
                    img{
                        width: 106px;
                        height: 60px;
                        margin-right: 10px;
                    }
                    span{
                        display: inline-block;
                        height: 42px;
                        overflow: hidden;
                    }
                }
            }
        }
    }
</style>